import React, { useEffect, useState } from "react"
import { Layout, WrapperMainComponent } from "../../../common/Layout"
import { SEO } from "../../../common/SEO"
import { Filters } from "../../../common/Filters"
import { DisplayProduct } from "./components/DisplayProduct"
import { FooterContainer } from "./components/FooterContainer"
import { ProductsCollectionLink } from "../../../common/ProductsCollectionLink"
import { ProductsDescription, ProductsDescriptionSEO } from "../../../common/ProductsDescription"
import { ProductsFaq } from "../../../common/ProductsFaq"
import { useBreadcrumbsBox } from "../../../common/Breadcrumbs/BreadcrumbsBox.container"
import { BrandView } from "./components/BrandView"
import { ColoredLine } from "../../../common/ColorLine"
import { useDetectDevice } from "../../../../lib/useDetectDevice"
import { Wrapper } from "./ProductsPagined.style"

interface Props {
  className?: string
  products?: any
  totalCount: number
  filters: any[]
  onFiltersChange: () => void
  categoryName?: string
  description?: string
  contenuSEO?: string
  liens_haut_page: string,
  liens_bas_page: string,
  faq: { question: string, reponse: string },
  seoTitle: string
  seoDescription: string
  titre_lien_bas_page: string
  pageInfo: { page: number, total: number }
  category: {}
  Marque: string
  DescriptionMarque: any
  LogoMarque: any
  LiensAssocies: any
  ImageMarque: any
}

export const ProductsPaginedView = ({
  products,
  totalCount,
  filters,
  onFiltersChange,
  className,
  categoryName = "Nos Produits",
  description,
  contenuSEO,
  liens_haut_page,
  liens_bas_page,
  faq,
  seoTitle,
  seoDescription,
  titre_lien_bas_page,
  pageInfo,
  category,
  Marque,
  DescriptionMarque,
  LogoMarque,
  LiensAssocies,
  ImageMarque,
}: Props) => {

  if (!products) products = []

  const isMobile = useDetectDevice()
  const [dataLength, setDataLength] = useState(0)
  const [hasMore, setHasmore] = useState(
    totalCount > Object.keys(products).length
  )
  useEffect(() => {
    setDataLength(Object.keys(products).length)
    setHasmore(totalCount > Object.keys(products).length)
  }, [products, totalCount])

  const [BreadcrumbsBox, NavigateBackButton] = useBreadcrumbsBox({ "category": category, "productName": categoryName })

  return (
    <Layout className={className}>
      <SEO
        title={seoTitle}
        description={seoDescription}
      />
      <BreadcrumbsBox />
      <BrandView Marque={Marque} DescriptionMarque={DescriptionMarque} LogoMarque={LogoMarque} LiensAssocies={LiensAssocies} ImageMarque={ImageMarque}  />
      <Wrapper className={isMobile && "mobile"}>
        <ProductsDescription data={description} />
        <ProductsCollectionLink data={liens_haut_page} />
      </Wrapper>
      {filters && (
        <Filters
          filters={filters}
          onFiltersChange={onFiltersChange}
          onClearFilter={onFiltersChange}
        />
      )}
      <Wrapper className={isMobile && "mobile"}>
        <DisplayProduct
          dataLength={dataLength}
          // onLoadMore={onLoadMore}
          hasMore={hasMore}
          products={products}
        ></DisplayProduct>
        <FooterContainer pageInfo={pageInfo} />
        <NavigateBackButton />
        <ColoredLine color={"#E9E9E9"} height={"1px"} width={"100%"} />
        <ProductsCollectionLink data={liens_bas_page} ><h1>{titre_lien_bas_page}</h1></ProductsCollectionLink>
      </Wrapper>
      <ProductsDescriptionSEO data={contenuSEO} />
      <Wrapper className={isMobile && "mobile"}>
        <ProductsFaq data={faq} />
      </Wrapper>
    </Layout>
  )
}


